import { Dispatch } from 'redux';
import { typedAction } from 'store/modules/base';
import {
  GETConvite,
  LOGINAuth,
  POSTCadastroUsuário,
  POSTNovaSenhaRequest,
  GETNovaSenhaRequest,
  PUTNovaSenhaRequest,
  LOGIN,
  GETFuncoes,
  GETUsuarios,
  POSTConvite,
  GETAllUsuarios,
  POSTGerarConvite,
  POSTReenviarConvite,
  GETConviteByEmail,
  DELETEUsuario,
  PATCHAtivarUsuario,
  PATCHDesbloquearUsuario,
  PUTUsuario,
  GETUsuarioMaster,
  //GETConsultoreslist,
} from 'requests/usuario';
import {
  LoginResponse,
  ConviteResponse,
  CadastroUsuarioRequest,
  UsuarioResponse,
  NovaSenhaRequestResponse,
  ParticipanteAuthResponse,
  UsuarioParticipanteApiResponse,
  ConviteRequest,
  UsuarioModelResponse,
  UsuarioEditRequest,
  UsuarioMasterResponse,
  FuncaoRequest,
  FuncaoModuloResponse,
  ConviteUsuarioRequest,
  ConviteDataResponse,
} from 'common/genericTypes';
import { GETModulosUsuario, PostModulosLimite } from 'requests/modulo';

export interface UsuarioApiState {
  loginAuth(
    dispatch: Dispatch,
    loginInfo: { email: string; senha: string; captchaToken: string, idpToken?: string }
  ): Promise<LoginResponse>;
  login(dispatch: Dispatch, participanteFuncaoUsuarioId: string): Promise<LoginResponse>;
  getConvite(dispatch: Dispatch, conviteId: string, stackRequest?: boolean): Promise<ConviteResponse>;
  getConviteByEmail(dispatch: Dispatch, email: string, stackRequest?: boolean): Promise<ConviteDataResponse>;
  postConvite(dispatch: Dispatch, convite: ConviteRequest, stackRequest?: boolean): Promise<unknown>;
  postGerarConvite(dispatch: Dispatch, convite: ConviteUsuarioRequest, stackRequest?: boolean): Promise<unknown>;
  postReenviarConvite(dispatch: Dispatch, convite: ConviteUsuarioRequest, stackRequest?: boolean): Promise<unknown>;
  postCadastrarUsuario(
    dispatch: Dispatch,
    conviteId: string,
    cadastroRequest: CadastroUsuarioRequest,
    stackRequest?: boolean
  ): Promise<UsuarioResponse>;
  postNovaSenhaRequest(dispatch: Dispatch, email: string, stackRequest?: boolean): Promise<NovaSenhaRequestResponse>;
  getNovaSenhaRequest(dispatch: Dispatch, id: string, stackRequest?: boolean): Promise<NovaSenhaRequestResponse>;
  putNovaSenhaRequest(
    dispatch: Dispatch,
    requestId: string,
    senha: string,
    stackRequest?: boolean
  ): Promise<UsuarioResponse>;
  getFuncoes(dispatch: Dispatch, stackRequest: boolean): Promise<ParticipanteAuthResponse[]>;
  getUsuarios(dispatch: Dispatch, stackRequest: boolean): Promise<UsuarioParticipanteApiResponse[]>;
  getAllUsuarios(dispatch: Dispatch, stackRequest?: boolean): Promise<UsuarioModelResponse[]>;
  postModulosLimite(
    dispatch: Dispatch,
    payload: FuncaoRequest,
    stackRequest?: boolean
  ): Promise<FuncaoModuloResponse[]>;
  deleteUsuario(dispatch: Dispatch, usuarioId: string, stackRequest?: boolean): Promise<unknown>;
  patchAtivarUsuario(dispatch: Dispatch, usuarioId: string, stackRequest?: boolean): Promise<unknown>;
  patchDesbloquearUsuario(dispatch: Dispatch, usuarioId: string, stackRequest?: boolean): Promise<unknown>;
  putUsuario(dispatch: Dispatch, request: UsuarioEditRequest, stackRequest?: boolean): Promise<unknown>;
  getUsuarioMaster(dispatch: Dispatch, emissorId: string, stackRequest?: boolean): Promise<UsuarioMasterResponse>;
  getModulosUsuario(
    dispatch: Dispatch,
    usuarioId: string,
    stackRequest?: boolean
  ): Promise<FuncaoModuloResponse[]>;
  //getConsultoreslist(dispatch: Dispatch, email: string): Promise<{isConsultor: boolean}>;
}

const usuarioApiInitialState: UsuarioApiState = {
  loginAuth: LOGINAuth,
  login: LOGIN,
  getConvite: GETConvite,
  postConvite: POSTConvite,
  postGerarConvite: POSTGerarConvite,
  postReenviarConvite: POSTReenviarConvite,
  getConviteByEmail: GETConviteByEmail,
  postCadastrarUsuario: POSTCadastroUsuário,
  postNovaSenhaRequest: POSTNovaSenhaRequest,
  getNovaSenhaRequest: GETNovaSenhaRequest,
  putNovaSenhaRequest: PUTNovaSenhaRequest,
  getFuncoes: GETFuncoes,
  getUsuarios: GETUsuarios,
  getAllUsuarios: GETAllUsuarios,
  postModulosLimite: PostModulosLimite,
  deleteUsuario: DELETEUsuario,
  patchAtivarUsuario: PATCHAtivarUsuario,
  patchDesbloquearUsuario: PATCHDesbloquearUsuario,
  putUsuario: PUTUsuario,
  getUsuarioMaster: GETUsuarioMaster,
  getModulosUsuario: GETModulosUsuario,
  //getConsultoreslist: GETConsultoreslist,
};

enum UsuarioApiActionType {
  Update = 'usuarioApi/UPDATE',
  Reset = 'usuarioApi/RESET',
}

export const updateUsuarioApi = (state: UsuarioApiState) => {
  return typedAction(UsuarioApiActionType.Update, state);
};

export const resetUsuarioApi = () => {
  return typedAction(UsuarioApiActionType.Reset);
};

type UsuarioApiAction = ReturnType<typeof updateUsuarioApi | typeof resetUsuarioApi>;

export function usuarioApiReducer(
  state: UsuarioApiState = usuarioApiInitialState,
  action: UsuarioApiAction
): UsuarioApiState {
  switch (action.type) {
    case UsuarioApiActionType.Update:
      return { ...action.payload };
    case UsuarioApiActionType.Reset:
      return { ...usuarioApiInitialState };
    default:
      return state;
  }
}
